import React from 'react';
import { Grid } from '@mui/material';
import Home from 'components/Home';
import CookieBanner from 'components/Cookies';

function Inicio() {

    return (
        <>

            <Grid>
                <Home />
                <CookieBanner />
            </Grid>

        </>
    )
}

export default Inicio
